import React from "react";
import BulkUploadFile from "../../BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkCityUploadActions from "../../../store/actions/CampaignCityMappingsUpload";
import { uploadUrl, sampleURL } from "../../../constants/Campaign/constants";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Disclaimer: This feature is only for updating the cities data for only one campaign at a time. Any previously linked cities which are not part of your csv will remain as it is. Multiple campaigns can be linked to a particular city, and campaign with latest created_at value will be picked up for the bonus in that city.",
];

const BulkCityUplaod = ({
  getBulkUploadUrl = () => {},
  customHandleClose = () => {},
}) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="BulkCityUploadBtn"
      uploadUrl={uploadUrl}
      sampleURL={sampleURL}
      id="BulkCityUploadModal"
      sendExtraAck
      keyName="callback_key"
      heading="Bulk City Upload"
      getUploadUrl={getBulkUploadUrl}
      customHandleClose={customHandleClose}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkCityUploadActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkCityUplaod);
